export const MONTH_NAMES = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december'
];

export const NL_PRIMEREACT_LOCALE = {
  firstDayOfWeek: 1,
  dayNamesMin: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  monthNames: MONTH_NAMES,
  today: 'Vandaag',
  clear: 'Wissen',
  dateFormat: 'yy-mm-dd',
  weekHeader: 'Wk'
};